$('input:checkbox').change(function(e){
  if($('input[name="contact[Party Package]"]:checked').val() == "Package A"){
    var limit = 2;
	console.log("Package A selected");        
  }else if($('input[name="contact[Party Package]"]:checked').val() == "Package B"){
    var limit = 3;
	console.log("Package B selected");
  }else if($('input[name="contact[Party Package]"]:checked').val() == "Package C"){
    var limit = 4;

  }else if($('input[name="contact[Party Package]"]:checked').val() == "Package D"){
    var limit = 8;

  }else if($('input[name="contact[Party Package]"]:checked').val() == "Package E"){
    var limit = 0;
  }

 if ($('input[type=checkbox]:checked').length > limit) {
      $(this).prop('checked', false)      
   	  alert("You've reached the max number of flavors allowed!");
 }
});


function uncheckAll() {
  $("input[type='checkbox']:checked").prop("checked", false)
}
$(':radio').on('click', uncheckAll)

/*
$(document).ready( function() {
    $(function() {
      $("#ContactFormDate").datepicker( {
        minDate: -0
        
      } );
    });
  });
*/